<template>
    <div class="row">
        <div class="col-md-8 col-xs-11">
            <h4 style="font-weight:bold">{{clientPractice.Name}}</h4>
            <h4>{{clientPractice.Address1}}</h4>
            <h4>{{clientPractice.City}} {{clientPractice.State}} {{clientPractice.Zip}} </h4>
            <h4 class="hidden-md hidden-lg hidden-sm" v-if="clientPractice.Mile>0">{{clientPractice.Mile}} mi
            </h4>
        </div>
        <div class="col-md-3 hidden-xs col-xs-2 no-margin-padding  text-center" style="padding-top:40px;">
             <h4 v-if="clientPractice.Mile>0">{{clientPractice.Mile}} mi
            </h4>
        </div>
        <div class="col-md-1 col-xs-1 no-margin-padding text-center" style="margin:0px;padding:0px;padding-top:40px;">
            <i class="material-icons pull-right">&#xE315;</i>
        </div>
    </div>
</template>

<script>
export default {
    name: "ClientPracticeDetail",
    props: ['clientPractice']
}
</script>



// WEBPACK FOOTER //
// src/components/ClientPracticeDetail.vue